






import Vue from 'vue'
import HomeSlogans from '../Home/Slogans.vue'

export default Vue.extend({
  name: 'Slogans',
  components: { HomeSlogans }
})
